import {
  /** FETCH CARTUPDATE  */
  FETCH_CARTUPDATE_FULFILLED,
  FETCH_CARTUPDATE_REJECTED,
  FETCH_CARTUPDATE_PENDING,
  RESET_CARTUPDATE,
} from "../../actions/payment/cartUpdate";

const initialState = {
  cartUpdate: null, // Sepet güncellemesiyle ilgili veriler
  done: false, // İşlem tamamlandı mı?
  error: null, // Hata durumunda hata mesajı
  spinner: false, // Yüklenme durumu
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARTUPDATE_PENDING:
      return {
        ...state,
        spinner: true,
        done: false,
        error: null,
      };

    case FETCH_CARTUPDATE_FULFILLED:
      return {
        ...state,
        cartUpdate: action.payload, // Güncellenen sepet verisi
        done: true,
        error: null,
        spinner: false,
      };

    case FETCH_CARTUPDATE_REJECTED:
      return {
        ...state,
        error: action.payload, // Hata mesajı ya da verisi
        done: false,
        spinner: false,
      };

    case RESET_CARTUPDATE:
      return {
        ...initialState, // initialState ile sıfırlama
      };

    default:
      return state;
  }
};
